import React, { useEffect, useState } from "react";
import accessURL from "../../../../components/utils/access";
import { useDateOfVisit } from "../../../../contexts/report/DateOfVisitContext";
interface ObjectiveInputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: string;
  }
  
  const ObjectiveInput: React.FC<ObjectiveInputProps> = ({
    value,
    onChange,
    error,
  }) => {
    const { dateOfVisit, customerDetails } = useDateOfVisit() ?? {};
    const [objective, setObjective] = useState("");
  
    const fetchObjective = async () => {
      try {
        const response = await accessURL.get(
          `/reports/objective?&dateOfVisit=${dateOfVisit}&name=${customerDetails?.customer}&time=${customerDetails?.time_of_visit}`
        );
        setObjective(response.data.data);
        // Simulate an onChange event to update parent form
        onChange({
          target: { name: "objective", value: response.data.data }
        } as React.ChangeEvent<HTMLInputElement>);
      } catch (error) {
        console.error("Error fetching objective:", error);
      }
    };
  
    useEffect(() => {
      fetchObjective();
    }, [dateOfVisit, customerDetails?.customer, customerDetails?.time_of_visit]);
  
    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Objective
        </label>
        <input
          type="text"
          className={`w-full p-2 border rounded-md ${
            error ? "border-red-500" : "border-gray-300"
          } focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-gray-50`}
          placeholder="Enter objective"
          name="objective"
          value={objective}
          disabled
          readOnly
        />
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    );
  };
  
  export default ObjectiveInput;